<template lang="pug">
  main
    section.section(v-show="hayDatos")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Nominaciones Mensuales
        .columns
          .column.is-12.has-text-centered
            .table-responsive
              table#tbNominaciones.table.is-striped.is-fullwidth
                thead
                  tr
                    th #
                    th Grupo
                    th Período
                    th Nominación
                    th
                tbody
                  tr(v-for="(data, index) in nominaciones" :key="data.id")
                    td {{ index + 1 }}
                    td
                      span.tag {{ data.grupo }}  - {{ data.nombreCompania }}
                      | &nbsp
                      a.button.is-danger.is-small.is-rounded(@click="eliminarNomMensual(data)")
                        span.icon
                          i.fas.fa-trash
                    td(v-html="convertirPeriodo(data)")
                    td
                      | {{data.nominacion}}
                    td
                      a.button.is-black(@click="generarNominaciones(data)") Nominación Diaria
</template>

<script>
  import nominaciones_irgeServices from '@/services/sca/nominaciones/nominacionesIrge.js'
  import { mapState } from "vuex"

  export default {
    name: 'ListOfNominacionesMensual',
    props: {
      updateComponente: {
        type: Boolean,
        default: false
      },
    },
    watch: {
      updateComponente() {
        if (this.updateComponente) {
          this.buscarNominaciones()
        }
      }
    },
    data() {
      return {
        isLoading: false,
        nominaciones: [],
        hayDatos: false,
        actualizarPadre: false
      }
    },
    methods: {
      buscarNominaciones() {
        nominaciones_irgeServices.getNominacionesMensual()
          .then( r=> {
            this.nominaciones = r
            this.actualizarPadre = true
            this.$emit('actualizarPadre', this.actualizarPadre)
            if (this.nominaciones.length > 0) {
              this.hayDatos = true
            } else {
              this.hayDatos = false
            }
          })
          .catch(e => console.log(e))
      },
      iniciarComponente() {
        this.buscarNominaciones()
      },
      convertirPeriodo (nom) {
        let texto = `${nom.anio} - ${nom.mes}`
        return texto
      },
      generarNominaciones(data) {
        this.$emit('genNominacionDiaria', data)
      },
      eliminarNomMensual (data) {
        this.$emit('deleteNomMensual', data)
      }
    },
    computed: {
      ...mapState(["logueado", "userLogin"])
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/nominaciones/componentes/ListOfNominacionesMensual.vue